// @ts-nocheck
import { name2num, num2name, } from "./(SubscriptionPayment)/Status";
import { name2num as name2num_1, num2name as num2name_1, } from "./SubscriptionRenewalInterval";
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "./SubscriptionPaymentDetail";
import { encodeJson as encodeJson_2, decodeJson as decodeJson_2, encodeBinary as encodeBinary_2, decodeBinary as decodeBinary_2, } from "../../google/protobuf/Timestamp";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../runtime/json/scalar";
import { WireType, } from "../../../runtime/wire/index";
import { default as serialize, } from "../../../runtime/wire/serialize";
import { default as Long, } from "../../../runtime/Long";
import { default as deserialize, } from "../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        status: "STATUS_UNSPECIFIED",
        renewalInterval: "SUBSCRIPTION_RENEWAL_INTERVAL_UNSPECIFIED",
        subscriptionPaymentDetail: undefined,
        createdAt: undefined,
        updatedAt: undefined,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.status !== undefined)
        result.status = tsValueToJsonValueFns.enum(value.status);
    if (value.renewalInterval !== undefined)
        result.renewalInterval = tsValueToJsonValueFns.enum(value.renewalInterval);
    if (value.subscriptionPaymentDetail !== undefined)
        result.subscriptionPaymentDetail = encodeJson_1(value.subscriptionPaymentDetail);
    if (value.createdAt !== undefined)
        result.createdAt = encodeJson_2(value.createdAt);
    if (value.updatedAt !== undefined)
        result.updatedAt = encodeJson_2(value.updatedAt);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.status !== undefined)
        result.status = jsonValueToTsValueFns.enum(value.status);
    if (value.renewalInterval !== undefined)
        result.renewalInterval = jsonValueToTsValueFns.enum(value.renewalInterval);
    if (value.subscriptionPaymentDetail !== undefined)
        result.subscriptionPaymentDetail = decodeJson_1(value.subscriptionPaymentDetail);
    if (value.createdAt !== undefined)
        result.createdAt = decodeJson_2(value.createdAt);
    if (value.updatedAt !== undefined)
        result.updatedAt = decodeJson_2(value.updatedAt);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.status !== undefined) {
        const tsValue = value.status;
        result.push([1, { type: WireType.Varint, value: new Long(name2num[tsValue]) }]);
    }
    if (value.renewalInterval !== undefined) {
        const tsValue = value.renewalInterval;
        result.push([2, { type: WireType.Varint, value: new Long(name2num_1[tsValue]) }]);
    }
    if (value.subscriptionPaymentDetail !== undefined) {
        const tsValue = value.subscriptionPaymentDetail;
        result.push([3, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    if (value.createdAt !== undefined) {
        const tsValue = value.createdAt;
        result.push([4, { type: WireType.LengthDelimited, value: encodeBinary_2(tsValue) }]);
    }
    if (value.updatedAt !== undefined) {
        const tsValue = value.updatedAt;
        result.push([5, { type: WireType.LengthDelimited, value: encodeBinary_2(tsValue) }]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.Varint ? num2name[wireValue.value[0]] : undefined;
        if (value === undefined)
            break field;
        result.status = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.Varint ? num2name_1[wireValue.value[0]] : undefined;
        if (value === undefined)
            break field;
        result.renewalInterval = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.subscriptionPaymentDetail = value;
    }
    field: {
        const wireValue = wireFields.get(4);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_2(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.createdAt = value;
    }
    field: {
        const wireValue = wireFields.get(5);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_2(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.updatedAt = value;
    }
    return result;
}
